import AuthGuard from '../components/AuthGuard';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import InnerLayout from '../components/InnerLayout';
import { api } from '../lib/api';

export default function BindPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', bank: '', card: '', wallet_type: '', wallet_address: '' });
  const [bound, setBound] = useState(false);
  const [types, setTypes] = useState<{ code: string; name: string }[]>([]);
  useEffect(() => {
    api.get('/bank/status').then(({ data }) => { setBound(!!data?.bound); if (data?.data) setForm({ name: data.data.name ?? '', bank: data.data.bank ?? '', card: data.data.card ?? '', wallet_type: data.data.wallet_type ?? '', wallet_address: data.data.wallet_address ?? '' }); });
    api.get('/wallet/types').then(({ data }) => { const arr = Array.isArray(data) ? data : []; setTypes(arr); if (!bound && arr.length) setForm(f => ({ ...f, wallet_type: f.wallet_type || arr[0].code })); });
  }, []);
  async function submit(e: React.FormEvent) {
    e.preventDefault(); if (!form.name || !form.bank || !form.card) { toast.error('请完整填写信息'); return; }
    try { const { data } = await api.post('/bank', form); toast.success(data?.message ?? '绑定成功'); setBound(true); }
    catch (err: any) { toast.error(err?.response?.data?.message ?? '绑定失败'); }
  }
  return (
    <div
      className="max-w-md mx-auto min-h-screen bg-[#8b0000]"
    >
      <AuthGuard />

      {/* Header */}
      <div className="relative pt-4 px-4">
        <button
          onClick={() => navigate(-1)}
          className="absolute top-4 left-4 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-white/80 text-black"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
        </button>
        <div className="flex flex-col items-center gap-3 justify-center relative mt-[-40px]">
          <h4>绑定银行卡</h4>
        </div>
      </div>

      <div className="mx-auto max-w-md px-4">

        <form className="space-y-3 flex flex-col gap-1 mt-5" onSubmit={submit}>
          <div className="mt-5 rounded-md bg-white p-4 shadow border-[1px] border-[#e5e7eb]">

            <div className="rounded-md mb-4 flex items-center gap-2 bg-cover bg-center bg-no-repeat" >
              <div className="flex flex-col gap-1 text-[#e50000]">
                {bound ? (
                  <>
                    <div className="text-md">已绑定银行卡</div>
                    <div className="text-[10px]">已绑定银行卡，可以进行提现</div>
                  </>
                ) : (
                  <>
                    <div className="text-md">未绑定银行卡</div>
                    <div className="text-[10px]">请尽快绑定银行卡享受更多福利</div>
                  </>
                )}
              </div>
            </div>

            <div className="flex justify-between items-center border-b border-gray-200">
              <div className="mb-1 text-[12px] w-[130px]">真实姓名</div>
              <input className="w-full bg-transparent p-3 text-right text-xs" placeholder="请输入真实姓名" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} disabled={bound} />
            </div>
            <div className="flex justify-between items-center border-b border-gray-200"><div className="mb-1 text-[12px] w-[130px]">银行名称</div><input className="w-full bg-transparent p-3 text-right text-xs" placeholder="请输入银行名称" value={form.bank} onChange={e => setForm({ ...form, bank: e.target.value })} disabled={bound} /></div>
            <div className="flex justify-between items-center border-b border-gray-200"><div className="mb-1 text-[12px] w-[130px]">银行卡号</div><input className="w-full bg-transparent p-3 text-right text-xs" placeholder="请输入银行卡号" value={form.card} onChange={e => setForm({ ...form, card: e.target.value })} disabled={bound} /></div>
            <div className="text-[12px] text-orange-600 mt-5">请确保银行卡号和姓名一致，否则无法正常收款</div>
          </div>
          <button className="w-full mt-5 bg-[#c4161c] py-2 text-[#fff] rounded-md" disabled={bound} type="submit">{bound ? '已绑定' : '确认绑定'}</button>
        </form>
      </div>
    </div>
  );
}